import React from "react";
import Nav from "../../components/nav/Nav";
import Hero from "./components/Hero";
import "./home.css";
import Aeroplane from "../../assets/plane.png";
import Ellipse from "../../assets/ellipse.png";

import CheckEligibility from "./components/checkEligibility/CheckEligibility";
import Results from "./components/Results";
import HowWorksClaim from "./components/HowWorksClaim";
import About from "./components/About";
import Instruct from "./components/Instruct";
import ClaimSection from "./components/ClaimSection";
import AirlineBrands from "./components/AirlineBrands";
import FileClaim from "./components/FileClaim";
import Footer from "../../components/footer/Footer";
import FaqSection from "./components/FaqSection";
import Carousel from "./components/CarouselSection";
import CarouselSection from "./components/CarouselSection";
import Contact from "../../components/contact/Contact";
import CompensationCalculator from "./components/CompensationCalculator";
import { useDisclosure } from '@mantine/hooks';
import { Modal, Button } from '@mantine/core';
const HomePage = () => {
  return (
    <div className="home-container">
      <img src={Ellipse} className="bg-image" />
      

      

      <Nav />
      <Hero />
      <About />

      <HowWorksClaim />

      <Results />

      <CheckEligibility />
      <CompensationCalculator/>
      <Instruct />
      <ClaimSection />
      <AirlineBrands />
      <CarouselSection/>
      <FileClaim />
      <FaqSection />
      <Contact/>
      <Footer/>
    </div>
  );
};

export default HomePage;
